//------------------------------------------------------------------------
// Sticky header functionality in desktop
// Demo https://projects.invisionapp.com/share/UGYSY0EW2Z8#/screens/431607529
//------------------------------------------------------------------------
export default class stickyHeader {
  constructor() {
    this.stickyHeaderHeight = 150;// must match $layout-header-height in _layout-vars.scss
    this.stickyClass = 'is-sticky';
    this.header = document.querySelector('.Header');

    // Nav breakpoint should match $layout-nav-bp in _layout-vars.scss
    this.mediaQueryList = window.matchMedia('(min-width: 1095px)');

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.init();
      } else {
        this.destroy();
      }
    });

    // Init on load
    if (this.mediaQueryList.matches) {
      this.init();
    }
  }

  scrollHandler(evt) {
    // Note: IE11 doesn’t support classList.toggle()
    if (window.scrollY > this.stickyHeaderHeight + 20) {
      document.documentElement.classList.add(this.stickyClass);
    } else {
      document.documentElement.classList.remove(this.stickyClass);
    }
  }

  init() {
    window.addEventListener('scroll', this.scrollHandler.bind(this));
  }

  destroy() {
    document.documentElement.classList.remove(this.stickyClass);
    window.removeEventListener('scroll', this.scrollHandler);
  }
}

// Init
new stickyHeader();